import { render, staticRenderFns } from "./PlanCardInfo.vue?vue&type=template&id=2cc1048c&scoped=true&"
import script from "./PlanCardInfo.vue?vue&type=script&lang=js&"
export * from "./PlanCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc1048c",
  null
  
)

export default component.exports